module.exports = __webpack_public_path__ + "img/company-logo.2fc0b616.svg";